import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const imageRoundFn = /* @__PURE__ */ createRecipe('image-round', {}, [])

const imageRoundVariantMap = {}

const imageRoundVariantKeys = Object.keys(imageRoundVariantMap)

export const imageRound = /* @__PURE__ */ Object.assign(memo(imageRoundFn.recipeFn), {
  __recipe__: true,
  __name__: 'imageRound',
  __getCompoundVariantCss__: imageRoundFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: imageRoundVariantKeys,
  variantMap: imageRoundVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, imageRoundVariantKeys)
  },
  getVariantProps: imageRoundFn.getVariantProps,
})